import {
  createSlice,
  Slice as SliceInterface,
} from "@reduxjs/toolkit";

const UserDataSlice: SliceInterface = createSlice({
  name: 'USER_DATA',
  initialState: {
    fullname: '',
    email: '',
    role: '',
  },
  reducers:{
    setUserData(state,action):any{
      return {...action.payload}
    }, 
  }
});

export const { setUserData } = UserDataSlice.actions;

export default UserDataSlice.reducer;
